import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { RootState } from './redux/rootReducer';
import { login, logout } from "./redux/authSlice";
import { AxiosResponse } from "axios";
import useApi from "./api";
import { gql, useMutation } from '@apollo/client';


import { deleteAllCookies } from './utils';


const REFRESH_TOKEN_MUTATION = gql`
  mutation RefreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      refresh {
        storeUrl
        token {
          expiresIn
          access
          refresh
          refreshExpiresIn
        }
        user {
          email
          firstName
          fullName
          id
          lastName
          role
          username
        }
        version
        baseCurrency
      }
    }
  }
`;

const PrivateRoute = () => {
  const isAuthenticated = useSelector((state: RootState) => !!state.auth.isLoggedIn);
  const dispatch = useDispatch();
  const api = useApi();
  const navigate = useNavigate();

  const [refreshTokenMutation] = useMutation(REFRESH_TOKEN_MUTATION);

  
  const refreshAccessToken = async () => {
    const currentRefreshToken = Cookies.get('refresh');
    
    if (currentRefreshToken) {
      try {
        const { data } = await refreshTokenMutation({
          variables: { refreshToken: currentRefreshToken },
        });

        const loginResponse = data.refreshToken.refresh; // Get the refreshed token data
        dispatch(login(loginResponse)); // Update Redux store with new access token and user info
      } catch (error) {
        deleteAllCookies();
        dispatch(logout()); // Logout if refresh token is invalid or expired
        navigate('/dashboard/login'); // Redirect to login page
      }
    }
  };
 
  
  

  useEffect(() => {
    refreshAccessToken();

    // Set up interval to refresh the token every 29 minutes
    const interval = setInterval(() => {
      refreshAccessToken();
    }, 29 * 60 * 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return isAuthenticated ? <Outlet /> : <Navigate to="/dashboard/login" />;
};

export default PrivateRoute;
